import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import {
  selectActualLicenses,
  selectEulaType,
  selectIsFirstLogin,
  selectShowEulaModal,
} from 'containers/App/selectors'

import EULAModal from 'components/elements/EULAModal/EULAModal'

import actions from './actions'
import { selectError, selectIsLoading, selectIsSuccussful, selectMessage } from './selectors'

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)
const mapStateToProps = (state) => ({
  licenses: selectActualLicenses(state),
  loader: selectIsLoading(state),
  message: selectMessage(state),
  error: selectError(state),
  success: selectIsSuccussful(state),
  showEula: selectShowEulaModal(state),
  eulaType: selectEulaType(state),
  isFirstLogin: selectIsFirstLogin(state),
})

const render = connect(mapStateToProps, mapDispatchToProps)(EULAModal)

export default render
